import { ContainerTypes, StepParams } from '@/types/containerTypes';
import { Step } from './step';

export class RepeatingStepChild extends Step {
  constructor(params: StepParams) { 
    super(params);
    this.containerType = ContainerTypes.RepeatingStepChild;
  }
}
